export const dismissSystemWideMessagesMutation = `mutation DismissSystemWideMessages($input: DismissSystemWideMessagesInput!) {
    dismissSystemWideMessages(input: $input) {
        status
    }
}`;
